<script lang="ts">
    import { getCachedEntries, postDBEntry, putDBEntry } from "../../../api"
    import Modal from "../../components/Modal.svelte"
    import Cta from "../../components/CTA.svelte"
    import { downloadAllImages, downloadSelectedImages } from "./helper"
    import hash from "object-hash"
    import { isMobile, login, newNotification } from "../../store"
    import { onChange } from "../../components/formComponents/helper"
    import Input from "../../components/formComponents/Input.svelte"
    import { copyObject } from "../utils"
    import LoadingWrapper from "./LoadingWrapper.svelte"
    import { createEventDispatcher } from "svelte"
    export let task: TaskOilSpillRemoval | TaskTowing,
        showModal = false

    let mediaFiles: Media[] = []
    const dispatch = createEventDispatcher()
    function setMediaFiles(fileReferences: string[]) {
        //check if all files already exist in mediaFiles
        const allFilesExist = fileReferences.every((f) => mediaFiles.find((m) => m.id === f))
        if (allFilesExist) return
        if (!fileReferences.length) {
            mediaFiles = []
            return
        }

        getCachedEntries("media", { _id: { $in: fileReferences || [] } }).then((response) => {
            mediaFiles = response
        })
    }
    let originalTaskFilesHash = "",
        originalObject = copyObject(task.files)
    $: if (!task.files) {
        task.files = []
        originalTaskFilesHash = hash(task.files)
        originalObject = copyObject(task.files)
    }
    $: if (task?.files && !originalTaskFilesHash) {
        originalTaskFilesHash = hash(task.files)
        originalObject = copyObject(task.files)
    }
    $: setMediaFiles((task.files || []).map((f) => f.id))
    $: catchAccidentalExit = {
        active: true,
        originalHash: originalTaskFilesHash,
        currentObject: task.files,
        originalObject: originalObject,
    }
    let isUploading = false

    const handleFileChange = async (event: Event) => {
        const input = event.target as HTMLInputElement
        isUploading = true
        if (input.files) {
            const filePromises = Array.from(input.files).map((file) => {
                return new Promise<Media>((resolve, reject) => {
                    const reader = new FileReader()
                    reader.onload = async (e: ProgressEvent<FileReader>) => {
                        try {
                            if (e.target && e.target.result) {
                                const res = await postDBEntry("media", {
                                    file: {
                                        path: file.name,
                                        type: file.type,
                                        size: file.size,
                                        src: typeof e.target.result === "string" ? e.target.result : "",
                                    },
                                    shotAt: null,
                                    uploadedAt: new Date(),
                                    location: {
                                        latitude: null,
                                        longitude: null,
                                    },
                                    comment: "",
                                    author: {
                                        id: $login.user.id,
                                    },
                                })
                                const entry: Media = res.data
                                resolve(entry)
                            }
                        } catch (error) {
                            reject(error)
                        }
                    }
                    reader.readAsDataURL(file)
                })
            })

            let files = await Promise.all(filePromises)
            task.files = [...(task.files || []), ...files.map((f) => ({ id: f.id }))]
            isUploading = false
        } else {
            isUploading = false
        }
    }
    let selectedFiles: boolean[] = []
</script>

<Modal
    show="{showModal}"
    showCloseIcon="{true}"
    size="xl"
    on:close="{() => {
        task.files = copyObject(originalObject)
        originalTaskFilesHash = hash(task.files)
        showModal = false
    }}"
    catchAccidentalExit="{catchAccidentalExit}"
>
    <h3
        class="label"
        slot="header"
    >
        <img
            src="../../../assets/icons/solar_folder-with-files-outline.svg"
            alt="icon"
        />
        <p>Dateien</p>
    </h3>

    <ul class="files form">
        <li class="upload">
            <LoadingWrapper
                active="{isUploading}"
                styles="width: 100%; height: 100%; display: flex; flex-direction: column;"
            >
                <button
                    class="uploadFile"
                    on:click|preventDefault|stopPropagation="{() => {
                        const input = document.createElement('input')
                        input.type = 'file'
                        input.multiple = true
                        input.onchange = handleFileChange
                        input.click()
                    }}"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.47 15.97C11.6106 15.8295 11.8012 15.7507 12 15.7507C12.1988 15.7507 12.3894 15.8295 12.53 15.97L14.53 17.97C14.6037 18.0387 14.6628 18.1215 14.7038 18.2135C14.7448 18.3055 14.7668 18.4048 14.7686 18.5055C14.7704 18.6062 14.7518 18.7062 14.7141 18.7996C14.6764 18.893 14.6203 18.9778 14.549 19.049C14.4778 19.1203 14.393 19.1764 14.2996 19.2141C14.2062 19.2518 14.1062 19.2704 14.0055 19.2686C13.9048 19.2668 13.8055 19.2448 13.7135 19.2038C13.6215 19.1628 13.5387 19.1037 13.47 19.03L12.75 18.31V22.5C12.75 22.6989 12.671 22.8897 12.5303 23.0303C12.3897 23.171 12.1989 23.25 12 23.25C11.8011 23.25 11.6103 23.171 11.4697 23.0303C11.329 22.8897 11.25 22.6989 11.25 22.5V18.31L10.53 19.03C10.4613 19.1037 10.3785 19.1628 10.2865 19.2038C10.1945 19.2448 10.0952 19.2668 9.99452 19.2686C9.89382 19.2704 9.79379 19.2518 9.7004 19.2141C9.60701 19.1764 9.52218 19.1203 9.45096 19.049C9.37974 18.9778 9.3236 18.893 9.28588 18.7996C9.24816 18.7062 9.22963 18.6062 9.23141 18.5055C9.23319 18.4048 9.25523 18.3055 9.29622 18.2135C9.33721 18.1215 9.39631 18.0387 9.47 17.97L11.47 15.97Z"
                            fill="#26292C"></path>
                        <path
                            d="M12.476 4.25C9.726 4.25 7.512 6.45 7.512 9.147C7.512 9.609 7.577 10.056 7.697 10.478C8.194 10.622 8.66 10.838 9.08 11.118C9.16639 11.1703 9.24132 11.2396 9.3003 11.3216C9.35927 11.4036 9.40108 11.4966 9.4232 11.5952C9.44533 11.6938 9.44732 11.7958 9.42906 11.8951C9.41079 11.9944 9.37265 12.0891 9.31692 12.1733C9.26118 12.2576 9.18901 12.3297 9.10472 12.3853C9.02044 12.441 8.92578 12.4791 8.82642 12.4972C8.72706 12.5154 8.62506 12.5133 8.52652 12.4911C8.42799 12.4689 8.33495 12.427 8.253 12.368C7.66992 11.9817 6.98546 11.7767 6.286 11.779C4.325 11.779 2.75 13.349 2.75 15.265C2.75 17.181 4.325 18.75 6.286 18.75C6.48491 18.75 6.67568 18.829 6.81633 18.9697C6.95698 19.1103 7.036 19.3011 7.036 19.5C7.036 19.6989 6.95698 19.8897 6.81633 20.0303C6.67568 20.171 6.48491 20.25 6.286 20.25C3.513 20.25 1.25 18.026 1.25 15.265C1.25 12.56 3.42 10.372 6.114 10.282C6.04614 9.90748 6.012 9.52762 6.012 9.147C6.012 5.606 8.914 2.75 12.476 2.75C15.634 2.75 18.272 4.994 18.831 7.971C21.131 8.948 22.75 11.209 22.75 13.853C22.75 16.927 20.562 19.484 17.657 20.106C17.4625 20.1476 17.2594 20.1103 17.0924 20.0022C16.9254 19.8941 16.8081 19.724 16.7665 19.5295C16.7249 19.335 16.7622 19.1319 16.8703 18.9649C16.9784 18.7979 17.1485 18.6806 17.343 18.639C19.583 18.159 21.25 16.193 21.25 13.853C21.25 11.716 19.86 9.891 17.912 9.225C17.3886 9.04599 16.8392 8.95476 16.286 8.955C15.703 8.955 15.146 9.055 14.628 9.235C14.4414 9.29593 14.2383 9.28126 14.0624 9.19415C13.8865 9.10704 13.7517 8.95443 13.6871 8.76909C13.6224 8.58374 13.633 8.38043 13.7166 8.2028C13.8001 8.02516 13.95 7.88737 14.134 7.819C15.1039 7.48042 16.1401 7.37591 17.158 7.514C16.8085 6.55419 16.1712 5.72564 15.3333 5.14147C14.4953 4.5573 13.4975 4.24597 12.476 4.25Z"
                            fill="#26292C"></path>
                    </svg>
                    <p>Dateien hochladen</p>
                </button>
            </LoadingWrapper>
        </li>
        {#each task.files || [] as file, i}
            <li class="file">
                <div class="file-wrapper">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="86"
                        height="86"
                        viewBox="0 0 86 86"
                        fill="none"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M16 53C16 52.2044 16.3161 51.4413 16.8787 50.8787C17.4413 50.3161 18.2044 50 19 50H51C51.7957 50 52.5587 50.3161 53.1213 50.8787C53.6839 51.4413 54 52.2044 54 53C54 53.7956 53.6839 54.5587 53.1213 55.1213C52.5587 55.6839 51.7957 56 51 56H19C18.2044 56 17.4413 55.6839 16.8787 55.1213C16.3161 54.5587 16 53.7956 16 53ZM16 67C16 66.2044 16.3161 65.4413 16.8787 64.8787C17.4413 64.3161 18.2044 64 19 64H41C41.7956 64 42.5587 64.3161 43.1213 64.8787C43.6839 65.4413 44 66.2044 44 67C44 67.7956 43.6839 68.5587 43.1213 69.1213C42.5587 69.6839 41.7956 70 41 70H19C18.2044 70 17.4413 69.6839 16.8787 69.1213C16.3161 68.5587 16 67.7956 16 67Z"
                            fill="#6C757D"></path>
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M44 6.336C42.16 6.024 39.648 6 35.12 6C27.452 6 22 6.008 17.872 6.56C13.824 7.1 11.5 8.12 9.808 9.808C8.116 11.5 7.1 13.82 6.56 17.844C6.008 21.956 6 27.372 6 35.004V51.004C6 58.628 6.008 64.044 6.56 68.156C7.1 72.18 8.116 74.5 9.808 76.196C11.5 77.884 13.82 78.9 17.844 79.44C21.956 79.996 27.372 80 35 80H51C58.628 80 64.048 79.992 68.16 79.44C72.18 78.9 74.5 77.884 76.192 76.192C77.884 74.5 78.9 72.18 79.44 68.156C79.992 64.048 80 58.628 80 51V49.252C80 43.108 79.96 40.196 79.304 38H66.784C62.252 38 58.552 38 55.624 37.608C52.572 37.196 49.924 36.308 47.808 34.192C45.692 32.076 44.804 29.432 44.392 26.372C44 23.452 44 19.748 44 15.212V6.336ZM50 9.44V15C50 19.8 50.008 23.096 50.34 25.572C50.66 27.964 51.236 29.136 52.052 29.948C52.864 30.764 54.036 31.34 56.428 31.66C58.904 31.992 62.2 32 67 32H75.08C73.545 30.5384 71.9848 29.1035 70.4 27.696L54.564 13.444C53.0701 12.0784 51.5484 10.7435 50 9.44ZM35.7 0C41.24 0 44.82 2.38419e-07 48.112 1.26C51.404 2.524 54.052 4.908 58.152 8.6L58.58 8.984L74.412 23.236L74.912 23.684C79.648 27.944 82.712 30.7 84.356 34.396C86.004 38.092 86.004 42.212 86 48.58V51.224C86 58.576 86 64.4 85.388 68.956C84.756 73.644 83.428 77.44 80.436 80.436C77.44 83.428 73.644 84.756 68.956 85.388C64.396 86 58.576 86 51.224 86H34.776C27.424 86 21.6 86 17.044 85.388C12.356 84.756 8.56 83.428 5.564 80.436C2.572 77.44 1.244 73.644 0.612 68.956C0 64.396 0 58.576 0 51.224V34.78C0 27.428 0 21.604 0.612 17.048C1.244 12.36 2.572 8.564 5.564 5.568C8.564 2.572 12.368 1.248 17.076 0.616C21.652 0.00400019 27.504 0.00400019 34.896 0.00400019H35.12L35.7 0Z"
                            fill="#6C757D"></path>
                    </svg>
                    <div class="actionRow">
                        <div class="selectedCheckbox">
                            <Input
                                type="checkbox"
                                bind:value="{selectedFiles[i]}"
                                onChange="{onChange}"
                                id="selected"
                                noPadding="{true}"
                            />
                        </div>
                        <button
                            class="removeElement"
                            on:click|preventDefault|stopPropagation="{() => {
                                delete selectedFiles[i]
                                task.files = task.files.filter((f) => f.id !== file.id)
                            }}"
                        >
                            <img
                                src="../../../assets/icons/solar_close-circle-outline-white.svg"
                                alt="icon"
                            />
                        </button>
                    </div>
                </div>
                <div class="filename">
                    <span class="key">Dateiname</span>
                    <span class="value">
                        {mediaFiles
                            .find((f) => f.id === file.id)
                            ?.file.path.split("/")
                            .pop() || ""}
                    </span>
                </div>
            </li>
        {/each}
    </ul>

    <div
        class="footer"
        slot="footer"
    >
        <div>
            <Cta
                type="tertiaryButton"
                icon="solar_download-minimalistic-outline"
                content="{$isMobile ? 'Auswahl' : 'Auswahl herunterladen'}"
                disabled="{selectedFiles.filter((f) => f).length === 0}"
                on:click="{(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    const filteredTaskFiles = task.files.filter((f, i) => selectedFiles[i])
                    downloadSelectedImages(filteredTaskFiles, mediaFiles, 'files')
                }}"
            />
        </div>
        <div>
            <Cta
                type="tertiaryButton"
                icon="solar_download-minimalistic-outline"
                disabled="{task.files.length === 0}"
                content="{$isMobile ? 'Alle' : 'Alle Dateien herunterladen'}"
                on:click="{(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    downloadAllImages(task, mediaFiles, 'files')
                }}"
            />
            <Cta
                type="primaryButton"
                icon="solar_diskette-outline"
                content="{$isMobile ? '' : 'Speichern'}"
                disabled="{originalTaskFilesHash === hash(task.files || [])}"
                on:click="{(e) => {
                    e.stopPropagation()
                    e.preventDefault()

                    // @ts-ignore
                    putDBEntry('task', {
                        id: task.id,
                        files: task.files,
                    })
                        .catch((error) => {
                            console.error('Error updating task', error)
                        })
                        .finally(() => {
                            dispatch('updateTaskFiles', task.files)
                            setTimeout(() => {
                                originalTaskFilesHash = hash(task.files || [])
                                originalObject = copyObject(task.files)
                                newNotification({
                                    html: 'Einsatzdateien aktuallisiert',
                                    class: 'success',
                                })
                            }, 100)
                        })
                }}"
            />
        </div>
    </div>
</Modal>

<style lang="less">
    @import "../../../../assets/variables.less";
    h3.label {
        display: flex;
        gap: 0.6rem;
        align-items: center;
    }
    .files {
        display: grid;
        grid-template-columns: repeat(auto-fill, 12rem);
        gap: 6px;
        @media @mobile {
            display: flex;
            flex-direction: column-reverse;
        }
        .uploadFile {
            min-height: 14rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 0.6rem;
            border-radius: 12px;
            border: 2px solid var(--grey-200);
            p {
                color: var(--text-100);
            }
            @media @mobile {
                max-height: 74px;
                min-height: 74px;
            }
        }
        li {
            width: 12rem;
            display: flex;
            flex-direction: column;
            @media @mobile {
                width: 100%;
            }
        }
        .file {
            overflow: hidden;
            .filename {
                display: flex;
                flex-direction: column;
                gap: 4px;
                padding: 0.3rem 0.6rem;
                .key {
                    color: var(--text-100);
                    font-family: Inter-bold;
                    font-size: 0.5rem;
                    font-weight: 700;
                    line-height: 0.5rem;
                    text-transform: uppercase;
                }
                .value {
                    color: var(--text-100);
                    font-family: Inter;
                    font-size: 0.5rem;
                    line-height: 0.5rem;
                    text-transform: uppercase;
                }
            }
            .file-wrapper {
                height: 12rem;
                width: 100%;
                position: relative;
                background-color: var(--grey-200);
                display: flex;
                align-items: center;
                justify-content: center;
                .actionRow {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    position: absolute;
                    top: 0.6rem;
                    left: 0.6rem;
                    right: 0.6rem;
                    .selectedCheckbox {
                        display: flex;
                        align-items: center;
                        width: 1.6rem;
                        height: 1.6rem;
                        gap: 0.6rem;
                        padding: 3px;
                        border-radius: 6px;
                        border: 1px solid var(--grey-200);
                        background: var(--white-100);
                    }

                    .removeElement {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 1.6rem;
                        height: 1.6rem;
                        border-radius: 48px;
                        background: var(--text-100);
                        img {
                            width: 1.2rem;
                            height: 1.2rem;
                        }
                    }
                }
                border-radius: 12px;
                svg {
                    width: 4.8rem;
                    height: 4.8rem;
                }
            }
        }
    }
    .footer {
        display: flex;
        width: 100%;
        justify-content: space-between;
        background-color: var(--grey-300);
        padding: 0px;
        div {
            display: flex;
            gap: 0.6rem;
        }
    }
</style>
